import React, { FC } from 'react';

import { useTheme } from '@mui/material';
import { styled } from '@mui/material';

import ChevronTopIcon from '~/assets/icons/ChevronTopIcon';
import useTenantTranslation from '~/hooks/useTenantTranslation';
import { SMALL_MARGIN_PX } from '~/theme';

interface ShowMoreBtnProps {
  listIsOpen: boolean;
  handleClick: () => void;
}

const ShowMoreBtn: FC<ShowMoreBtnProps> = ({ listIsOpen, handleClick }) => {
  const theme = useTheme();
  const { t } = useTenantTranslation();

  return (
    <Btn onClick={handleClick}>
      <Text>{listIsOpen ? t('button.showLess') : t('button.showMore')}</Text>
      <Icon color={theme.palette.common.star} listIsOpen={listIsOpen} />
    </Btn>
  );
};

export default ShowMoreBtn;

const Btn = styled('button')`
  display: flex;
  align-items: center;
  cursor: pointer;
  background-color: ${({ theme }) => theme.palette.common.transparent};
  border: none;
  align-self: flex-start;
  z-index: 2;
  margin-top: -1px;
  &:focus {
    outline: none;
  }
  padding: 5px 0;
`;
const Text = styled('span')`
  font-size: 16px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.common.button.collapseSecondary};
`;
const Icon = styled(ChevronTopIcon, {
  shouldForwardProp: (prop) => prop !== 'listIsOpen',
})`
  width: 16px;
  height: 16px;
  cursor: pointer;
  transform: ${({ listIsOpen }) => (listIsOpen ? 'none' : 'rotate(180deg)')};
  transition: transform 0.3s ease-out;
  margin-left: ${SMALL_MARGIN_PX};
`;
